import { useQuery } from '@tanstack/react-query';
import clientApi from '~/clientApi';
import { SavedList } from '~/clientApi/savedLists.model';
import { SAVED_LISTS } from '~/queries/keys';

interface Params {
  id?: string;
  properties?: string[];
}

const getSavedListData = ({ id, properties }: Params): Promise<SavedList> =>
  clientApi.savedLists.read({ id, properties });

export const useGetSavedList = ({ id, properties }: Params) =>
  useQuery({
    queryKey: [SAVED_LISTS, id],
    queryFn: () => getSavedListData({ id, properties }),
    enabled: Boolean(id?.length),
  });
